import { deleteData, getData, putData } from "../axiosConfig";

export const getUsers = async () => {
  return await getData("/admin/users");
};

export const notAssignedVoucher = async () => {
  return await getData("/admin/not-assigned-vouchers");
};

export const assignVoucher = async (id, userid) => {
  return await putData(`/admin/users/assigned-voucher/${id}/${userid}`);
};
export const deleteVoucher = async (id) => {
  return await putData(`/admin/users/assigned-voucher/${id}`);
};

export const deleteUsers = async (id) => {
  return await deleteData(`/admin/users/${id}`);
};

// export const getTransactions = async (id) => {
//   return await getData(`/admin/users/transactions/${id}`);
// };


export const getTransactions = async (id, startDate = "", endDate = "") => {
  if (startDate && endDate) {
    return await getData(
      `/admin/users/transactions/${id}?start_date=${startDate}&end_date=${endDate}`
    );
  } else {
    return await getData(`/admin/users/transactions/${id}`);
  }
};

export const getUserAccountDetail = async (id) => {
  return await getData(`/admin/users/account-detail/${id}`);
};


export const getUserWithdrawableTransactions = async (id, startDate = "", endDate = "") => {
  if (startDate && endDate) {
    return await getData(
      `/admin/users/withdrawl-request/${id}?start_date=${startDate}&end_date=${endDate}`
    );
  } else {
    return await getData(`/admin/users/withdrawl-request/${id}`)
  }
};

export const getPayoutsRequest = async () => {
  return await getData(`admin/payouts-request`);
};

export const updatePayoutsRequest = async (id) => {
  return await getData(`/admin/payouts-request/approve/${id}`);
};

export const getNewsletter = async () => {
  return await getData(`admin/newsletter-emails`);
};
export const getCoupons = async () => {
  return await getData(`admin/discount-vouchers`);
};
